import React from "react";
import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Send, Users, Mail, Sparkles, KeyRound } from "lucide-react";

const TABS = [
  { to: "telegram",    label: "Telegram",       icon: Send,     perm: "settings.manage" },
  { to: "mitarbeiter", label: "Mitarbeiter",    icon: Users,    perm: "team.manage" },
  { to: "email",       label: "E-Mail-Import",  icon: Mail,     perm: "settings.manage" },
  { to: "ki-pruefung", label: "KI-Prüfung",     icon: Sparkles, perm: "ai.review" },
  { to: "api-keys",    label: "API-Zugänge",    icon: KeyRound, perm: "apikeys.manage" },
];

export default function Settings() {
  const { has } = useAuth();
  const location = useLocation();

  const visible = TABS.filter((t) => !t.perm || has(t.perm));

  // If URL is exactly /app/einstellungen (no sub-tab) → jump to first tab the user can see
  const isExactRoot = location.pathname.replace(/\/$/, "").endsWith("/einstellungen");
  if (isExactRoot && visible.length > 0) {
    return <Navigate to={visible[0].to} replace />;
  }

  return (
    <div className="min-h-full bg-[#FAFAF8]" data-testid="settings-shell">
      {/* Tab bar */}
      <div className="sticky top-0 z-10 bg-[#FAFAF8]/95 backdrop-blur border-b border-[#E6E6E4]">
        <div className="px-8 pt-6 pb-0">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C5E60] font-semibold mb-1">Einstellungen</div>
          <div className="flex items-end gap-1 overflow-x-auto -mx-1 px-1">
            {visible.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                data-testid={`settings-tab-${tab.to}`}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 px-4 py-2.5 text-sm border-b-2 transition-colors whitespace-nowrap ${
                    isActive
                      ? "border-[#18322B] text-[#18322B] font-semibold"
                      : "border-transparent text-[#5C5E60] hover:text-[#18322B] hover:border-[#C6C6C4]"
                  }`
                }
              >
                <tab.icon className="h-4 w-4" strokeWidth={1.75} />
                {tab.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Tab content */}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
